import PropTypes from 'prop-types';

const FULL = 'PageLayoutFull';
const SIDEBAR = 'PageLayoutSidebar';
const FLYOUT = 'PageLayoutFlyout';

export { FULL, SIDEBAR, FLYOUT };

export default PropTypes.oneOf([FULL, SIDEBAR, FLYOUT]);
